module.exports = __webpack_public_path__ + "img/mi-home.66a7ed63.svg";